// import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import WithdrawHeader from "@/components/HomeHeader/indexWithdrawHeader";
import InviteProgress from "@/components/InviteProgress";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FunctionalConfig, LocalConfig, NumericalConfig, PaymentConfig } from "@/config";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendEvent } from "@/utils/Analytics";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useContext, useState, useEffect, useCallback, useRef } from "react";
import { Form, Picker, Popup, Toast, Popover } from "react-vant";
import DownloadFloatBall from "@/components/DownloadFloatBall";
import { FromInstalled } from "@/utils/BroswerHelper";
import InviteProgress2 from "@/components/InviteProgress2";
import { FormatNumberToKMB } from "@/utils/JSTool";

import style from "./style.less";
import inviteRouteStyle from "@/routes/Invite/style.less";

const games = {
  208: {
    id: 208,
    url: process.env.PREACT_APP_ENV_CONFIG.game3Url + "?game_id=208",
  },
};
const Withdraw = () => {
  const { getPersist, setPersist, reloadUserInfo } = useContext(PersistContext);
  const { getLanguage, langText } = useContext(LanguageContext);
  const inputRef = React.useRef(null);
  const gasPopoverRef = React.useRef(null);
  const userInfo = getPersist("user_info");
  const history = useEnhancedHistory();
  const phone = getPersist("last_phone");
  const [formWithdraw] = Form.useForm();
  const [downloadFloatBall, setDownloadFloatBall] = useState(false);
  const onFinishWithdraw = (values) => {
    console.log(values);
  };

  const [showHelp, setShowHelp] = useState(false);

  const [showSwitchChannelTip, setShowSwitchChannelTip] = useState(false);

  //输入框
  const [stateWithdraw, setStateWithdraw] = useState(0);
  const [suficientData, setSuficientData] = useState(null);

  const [money, setMoney] = useState(0);
  const [gas, setGas] = useState(0);
  const bankNameInputRef = React.useRef(getPersist("bankName"));
  const [bankName, setBankName] = useState(getPersist("bankName"));
  const bankCodeInputRef = React.useRef(getPersist("bankCode"));
  const [bankCode, setBankCode] = useState(getPersist("bankCode"));
  const accountNameInputRef = React.useRef(getPersist("accountName"));
  const [accountName, setAccountName] = useState(getPersist("accountName"));
  const cardNumberInputRef = React.useRef(getPersist("cardNumber"));
  const [cardNumber, setCardNumber] = useState(getPersist("cardNumber"));
  const bankAccountInputRef = React.useRef(getPersist("bankAccount"));
  const [bankAccount, setBankAccount] = useState(getPersist("bankAccount"));
  const bankCodeTwoInputRef = React.useRef(getPersist("bankCodeTwo"));
  const [bankCodeTwo, setBankCodeTwo] = useState(getPersist("bankCodeTwo"));
  // const [bankNameTwo, setBankNameTwo] = useState(getPersist("bankNameTwo") || 0);

  const [bankChooseCode, setBankChooseCode] = useState(getPersist("bankChooseCode") || 0);
  const bankChooseNameInputRef = React.useRef(getPersist("bankChooseName") || "");
  const [bankChooseName, setBankChooseName] = useState(getPersist("bankChooseName"));
  const cardChooseNumberInputRef = React.useRef(getPersist("cardChooseNumber") || "");
  const [cardChooseNumber, setCardChooseNumber] = useState(getPersist("cardChooseNumber"));
  const cardChooseExtraInputRef = React.useRef(getPersist("cardChooseExtra") || "");
  const [cardChooseExtra, setCardChooseExtra] = useState(getPersist("cardChooseExtra"));


  const [showChooseChannel, setShowChooseChannel] = useState(false);
  const [paymentIndex, setPaymentIndex] = useState(0);
  const [payments, setPayments] = useState(
    PaymentConfig.payments.map((item, index) => {
      return {
        value: index,
        text: item.text,
        type: item.type,
      };
    })
  );

  const [showCodeChooseChannel, setShowCodeChooseChannel] = useState(false);
  const [codeIndex, setCodeIndex] = useState(getPersist("bankChooseCode") || 0);
  const [codes, setCodes] = useState(
    PaymentConfig.codes && PaymentConfig.codes.map((item, index) => {
      return {
        value: index,
        id: item.codeId,
        text: item.codeText,
        msg: item.codeMsg,
      };
    }) || {}
  );

  const [purseIndex, setPurseIndex] = useState(0);
  console.log("PaymentConfig.purses", PaymentConfig.purses[27]);

  const [showNameChooseChannel, setShowNameChooseChannel] = useState(false);
  const [nameIndex, setNameIndex] = useState(getPersist("bankNameTwo") || 0);
  const [names, setNames] = useState(
    PaymentConfig.names && PaymentConfig.names.map((item, index) => {
      return {
        value: index,
        text: item.nameText,
      };
    }) || {}
  );

  const [minWithdraw, setMinWithdraw] = useState(NumericalConfig.minWithdrawAmount);
  const [maxWithdraw, setMaxWithdraw] = useState(NumericalConfig.maxWithdrawAmount);
  const [withdrawLevel, setWithdrawLevel] = useState(0);
  const [withdrawExp, setWithdrawExp] = useState(0);
  const [channelLimits, setChannelLimits] = useState({});

  const [contactType, setContactType] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  let withdrawableAmount = money ? money : 0;
  if (NumericalConfig.gasBurnRatio > 0) {
    withdrawableAmount = Math.min(money ? money : 0, gas ? gas / NumericalConfig.gasBurnRatio : 0);
  }

  let levelConfig = null;
  if (NumericalConfig.useWithdrawLevel > 0) {
    if (getPersist("bgSettings").configs) {
      levelConfig = getPersist("bgSettings").configs.user_level;
      if (levelConfig) {
        levelConfig = Object.values(levelConfig);
      }
    }
  }

  useEffect(() => {
    let bgSettings = getPersist("bgSettings");
    let merchant_usage = 0;
    let merchant_usable = [];
    if (bgSettings && bgSettings.settings && bgSettings.settings.merchant_usage) {
      merchant_usage = bgSettings.settings.merchant_usage;
    }
    if (bgSettings && bgSettings.settings && bgSettings.settings.client_config && bgSettings.settings.client_config.contactType) {
      setContactType(bgSettings.settings.client_config.contactType);
    }
    if (bgSettings && bgSettings.settings && bgSettings.settings.client_config && bgSettings.settings.client_config.contactNumber) {
      setContactNumber(bgSettings.settings.client_config.contactNumber);
    }
    if (
      bgSettings &&
      bgSettings.settings &&
      bgSettings.settings.client_config &&
      bgSettings.settings.client_config.withdrawPayments
    ) {
      for (let i = 0; i < bgSettings.settings.client_config.withdrawPayments.length; i++) {
        if (bgSettings.settings.client_config.withdrawPayments[i].usable) {
          merchant_usable.push(bgSettings.settings.client_config.withdrawPayments[i].id);
        }
      }
    }
    if (merchant_usable.length <= 0) {
      merchant_usable.push(merchant_usage);
    }
    console.log("bgSettings", bgSettings);
    console.log("merchant_usable", merchant_usable);
    console.log("merchant_usage", merchant_usage);
    let tmpPayments = [];
    let defaultWithdrawIndex = 0;
    let userPhone = getPersist("user_info") ? getPersist("user_info").rolename : "";
    if (!userPhone || userPhone == "") {
      userPhone = getPersist("last_phone");
    }
    PaymentConfig.payments
      .filter((item) => merchant_usable.indexOf(item.merchantId) != -1)
      .map((item, index) => {
        if (userPhone && item.checkPrecedence(userPhone)) {
          defaultWithdrawIndex = tmpPayments.length;
        }
        tmpPayments.push({
          value: index,
          ...item,
        });
        if (
          bgSettings.settings.client_config.defaultWithdraw &&
          bgSettings.settings.client_config.defaultWithdraw == item.merchantId &&
          tmpPayments[defaultWithdrawIndex].merchantId != bgSettings.settings.client_config.defaultWithdraw
        ) {
          defaultWithdrawIndex = index;
        }
      });
    console.log("tmpPayments", tmpPayments);
    console.log("defaultWithdrawIndex", defaultWithdrawIndex);
    setPayments(tmpPayments);
    setPaymentIndex(defaultWithdrawIndex);
  }, [getPersist("bgSettings")]);

  useEffect(() => {
    let payment = payments[paymentIndex];
    if (!payment) {
      return
    }
    if (payment.minWithdrawAmount) {
      setMinWithdraw(payment.minWithdrawAmount);
      if (inputRef.current.value < payment.minWithdrawAmount / 100) {
        setStateWithdraw(payment.minWithdrawAmount / 100);
      }
    }
    if (payment.maxWithdrawAmount) {
      setMaxWithdraw(
        Math.min(payment.maxWithdrawAmount, levelConfig && withdrawLevel ? levelConfig[withdrawLevel].withdraw_limit : 9999999999)
      );
      if (inputRef.current.value > payment.maxWithdrawAmount / 100) {
        setStateWithdraw(payment.maxWithdrawAmount / 100);
      }
    }
  }, [paymentIndex, payments]);
  const onWithdrawInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      if (typeof value == "string") {
        value = parseInt(value, 10);
      }
      if (value > maxWithdraw / 100) {
        value = maxWithdraw / 100;
      }
      if (value < 1) {
        value = 1;
      }
      inputRef.current.value = value;
      setStateWithdraw(value);
    }
  };

  const onGoPlayClick = () => {
    history.push(ChannelRemind(`/game?game_id=${games[208].id}&url=${encodeURI(games[208].url)}`));
  };

  const onGoDepositClick = () => {
    history.push(ChannelRemind("/deposit"));
  };
  React.useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      history.replace(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}back_to=-1`));
      return;
    }
    setMoney(getPersist("user_info").money.coin / 100);
    setGas(getPersist("user_info").money.gas ? getPersist("user_info").money.gas / 100 : 0);
    setWithdrawLevel(getPersist("user_info").level || 0);
    setWithdrawExp(getPersist("user_info").exp || 0);
    SendCMD("getWithdrawLevels", {
      token: getPersist("user_info").token,
    }).then((res) => {
      setSuficientData(res.data);
      if (!res.data.sufficient) {
        SendEvent("withdraw_visit_success");
      } else {
        SendEvent("withdraw_visit_failed");
      }
      if (res.limits) {
        setChannelLimits(res.limits);
      }
    });
    reloadUserInfo();
  }, [getPersist("dataLoaded"), getPersist("user_info")]);

  useEffect(() => {
    //下载悬浮球
    if (!FromInstalled) {
      setDownloadFloatBall(true);
    }
    // 每次重新进入页面时，将缓冲中提现时间戳归零
    setPersist("withdrawLastTime", null);
  }, []);

  const doWithdraw = async () => {
    if (showSwitchChannelTip) {
      Toast.info({ message: langText("withdraw_tips_92"), duration: 2000 });
      return;
    }

    let curTimestamp = new Date().getTime();
    if (getPersist("withdrawLastTime") && getPersist("withdrawLastTime") + 5000 > curTimestamp) {
      Toast.info({ message: langText("withdraw_tips_39", { param1: Math.ceil((getPersist("withdrawLastTime") + 5000 - curTimestamp) / 1000) }), duration: 2000 });
      return;
    } else if (getPersist("withdrawLastTime") && getPersist("withdrawLastTime") + 5000 < curTimestamp) {
      setShowSwitchChannelTip(true);
      setPersist("withdrawLastTime", null);
      Toast.info({ message: langText("withdraw_tips_92"), duration: 2000 });
      return;
    }

    if (stateWithdraw < minWithdraw / 100) {
      Toast.info({ message: langText("withdraw_tips_40", { param1: minWithdraw / 100 }), duration: 2000 });
      return;
    }
    if (stateWithdraw > maxWithdraw / 100) {
      Toast.info({ message: langText("withdraw_tips_41", { param1: maxWithdraw / 100 }), duration: 2000 });
      return;
    }
    if (stateWithdraw > money) {
      Toast.info({ message: langText("withdraw_tips_42"), duration: 2000 });
      return;
    }
    if (NumericalConfig.gasBurnRatio > 0 && stateWithdraw > gas / NumericalConfig.gasBurnRatio) {
      Toast.info({ message: langText("withdraw_tips_43"), duration: 2000 });
      return;
    }

    //如果Withdrawtype是BANKCARD，检查银行卡信息
    if (payments[paymentIndex] && payments[paymentIndex].type == "BANKCARD") {
      // if (!bankName || bankName == "") {
      //   Toast.info({ message: `Please input bank name`, duration: 2000 });
      //   return;
      // }
      if (!bankCode || bankCode == "") {
        Toast.info({ message: langText("withdraw_tips_44"), duration: 2000 });
        return;
      }
      if (!accountName || accountName == "") {
        Toast.info({ message: langText("withdraw_tips_45"), duration: 2000 });
        return;
      }
      if (!cardNumber || cardNumber == "") {
        Toast.info({ message: langText("withdraw_tips_46"), duration: 2000 });
        return;
      }

      let regex = /^(?=[a-zA-Z0-9]{11}$)/;
      if (!regex.test(bankCode)) {
        Toast.info({ message: langText("withdraw_tips_54"), duration: 2000 });
        return;
      }
    }

    //如果Withdrawtype是BANKNAME，检查银行卡信息
    if (payments[paymentIndex] && payments[paymentIndex].type == "BANKNAME") {
      if (!bankCodeTwo || bankCodeTwo == "") {
        Toast.info({ message: langText("withdraw_tips_44"), duration: 2000 });
        return;
      }

      let regex = /^0[0-9]{10}$/;
      if (!regex.test(bankCodeTwo)) {
        Toast.info({ message: langText("withdraw_tips_65"), duration: 2000 });
        return;
      }
    }

    //如果Withdrawtype是BANKCHOOSE，检查银行卡信息
    if (payments[paymentIndex] && payments[paymentIndex].type == "BANKCHOOSE") {
      if (PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "EASYPAISA" || PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "JAZZCASH") {
        if (cardChooseNumber && cardChooseNumber.length != 10) {
          Toast.info({ message: langText("withdraw_tips_67"), duration: 2000 });
          return;
        }
        if (PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "JAZZCASH" && cardChooseExtra && cardChooseExtra.length != 13) {
          Toast.info({ message: langText("withdraw_tips_77"), duration: 2000 });
          return;
        }
      }
      if (!bankChooseName || bankChooseName == "") {
        Toast.info({ message: langText("withdraw_tips_45"), duration: 2000 });
        return;
      }
      if (!cardChooseNumber || cardChooseNumber == "") {
        Toast.info({ message: langText("withdraw_tips_46"), duration: 2000 });
        return;
      }
      if (payments[paymentIndex].merchantId == 27 && PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "JAZZCASH" && !cardChooseExtra || cardChooseExtra == "") {
        Toast.info({ message: langText("withdraw_tips_75"), duration: 2000 });
        return;
      }
    }

    //如果Withdrawtype是UPI，检查UPI信息
    if (payments[paymentIndex] && payments[paymentIndex].type == "UPI") {
      if (!bankAccount || bankAccount == "") {
        Toast.info({ message: langText("withdraw_tips_47"), duration: 2000 });
        return;
      }
    }

    if (!suficientData || !suficientData.sufficient) {
      let res = await SendCMD("getWithdrawLevels", {
        token: getPersist("user_info").token,
      });
      if (!res.status) {
        Toast.fail({
          message: langText("withdraw_tips_48"),
          duration: 2000,
        });
        console.log(res.errdesc);
        return;
      } else if (!res.data.sufficient) {
        setSuficientData(res.data);
        return;
      }
      setSuficientData(res.data);
    }

    if (stateWithdraw > 0) {
      let data = {
        token: getPersist("user_info").token,
        price: Number(stateWithdraw) * 100,
        merchant_id: process.env.PREACT_APP_ENV_CONFIG.merchantId,
        withdraw_type: payments[paymentIndex].type,
      };
      if (payments[paymentIndex]) {
        console.log("payments[paymentIndex]", payments[paymentIndex]);
        data.type = payments[paymentIndex].type;
        data.merchant_id = payments[paymentIndex].merchantId;
      } else {
        Toast.info({ message: langText("withdraw_tips_49"), duration: 2000 });
      }
      if (payments[paymentIndex] && payments[paymentIndex].type == "BANKCARD") {
        // data.bank_name = bankName;
        data.bank_code = bankCode;
        data.account_name = accountName;
        data.card_number = cardNumber;
      } else if (payments[paymentIndex].type == "BANKCHOOSE") {
        data.bank_code = PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "BANK"
          ? payments[paymentIndex].merchantId == 32
            ? codes[bankChooseCode].msg
            : codes[bankChooseCode].id
          : PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text;
        data.account_name = bankChooseName;
        data.card_number = cardChooseNumber;
        data.extra = cardChooseExtra;
      } else if (payments[paymentIndex].type == "UPI") {
        console.log("bankAccount", bankAccount);
        data.card_number = bankAccount;
      } else if (payments[paymentIndex].type == "BANKNAME") {
        data.bank_code = bankCodeTwo;
        data.account_name = names[purseIndex].text;
      }

      //检查有没有低于或者超过limits
      if (
        channelLimits[data.merchant_id] &&
        channelLimits[data.merchant_id].min &&
        data.price < channelLimits[data.merchant_id].min / 100
      ) {
        Toast.info({
          overlay: true,
          className: style.limit_toast,
          message: (
            <div>
              {langText("withdraw_tips_50")}{" "}
              <span style={{ color: "red" }}>
                {channelLimits[data.merchant_id].min / 100}
                {LocalConfig.currencyCode}
              </span>
              .<br /> {langText("withdraw_tips_51")}
            </div>
          ),
          duration: 5000,
        });
        return;
      }
      if (
        channelLimits[data.merchant_id] &&
        channelLimits[data.merchant_id].max &&
        data.price > channelLimits[data.merchant_id].max / 100
      ) {
        Toast.info({
          overlay: true,
          className: style.limit_toast,
          message: (
            <div>
              {langText("withdraw_tips_52")}{" "}
              <span style={{ color: "red" }}>
                {channelLimits[data.merchant_id].max / 100}
                {LocalConfig.currencyCode}
              </span>
              .<br /> {langText("withdraw_tips_53")}
            </div>
          ),
          duration: 5000,
        });
        return;
      }
      // 都没问题可以提交之后屏蔽掉按钮点击5秒,保留当前时间戳
      setPersist("withdrawLastTime", new Date().getTime())
      SendCMD("withdraw", data).then((res) => {
        if (!res.status) {
          SendEvent("withdraw_request_failed", { price: data.price, reason: res.errdesc });
          if (res.errdcode === "withdraw_over_level_limit") {
            Toast.fail({
              message: langText("withdraw_tips_38"),
              duration: 8000,
              overlay: true,
            });
          } else {
            Toast.fail({
              message: langText("withdraw_tips_99"),
              duration: 10000,
              className: style.custom_toast,
              closeOnClick: true,
              overlay: true
            });
          }
          console.log(res.errdesc);
        } else if (res.data.need_audit) {
          SendEvent("withdraw_risk_management");
          history.push(ChannelRemind("/withdrawControl"));
        } else {
          SendEvent("withdraw_request_success", { price: data.price });
          Toast.success({
            message: langText("withdraw_tips_37"),
            duration: 2000,
            onClose: function () {
              setStateWithdraw("");
              location.reload();
            },
          });
        }
      });
    }
  };
  let amountPlaceholder = `${(minWithdraw / 100).toFixed(0)} - ${(maxWithdraw / 100).toFixed(0)}`;
  const onBankInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      bankNameInputRef.current.value = value;
      setBankName(value);
      setPersist("bankName", value);
    }
  };
  const onBankCodeInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      bankCodeInputRef.current.value = value;
      setBankCode(value);
      setPersist("bankCode", value);
    }
  };
  const onAccountInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      accountNameInputRef.current.value = value;
      setAccountName(value);
      setPersist("accountName", value);
    }
  };
  const onCardInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    //value移除所有非数字字符
    value = value.replace(/[^\d]/g, "");
    if (value) {
      cardNumberInputRef.current.value = value;
      setCardNumber(value);
      setPersist("cardNumber", value);
    }
  };
  const onBankAccountInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      bankAccountInputRef.current.value = value;
      setBankAccount(value);
      setPersist("bankAccount", value);
    }
  };
  const onBankCodeTwoInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      bankCodeTwoInputRef.current.value = value;
      setBankCodeTwo(value);
      setPersist("bankCodeTwo", value);
    }
  };
  // const onBankNameTwoInputChange = (e) => {
  //   let value = e.target.value;
  //   console.log(value);
  //   if (value) {
  //     bankNameTwoInputRef.current.value = value;
  //     setBankNameTwo(value);
  //     setPersist("bankNameTwo", value);
  //   }
  // };
  const onBankChooseNameInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      bankChooseNameInputRef.current.value = value;
      setBankChooseName(value);
      setPersist("bankChooseName", value);
    }
  };
  const onCardChooseNumberInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      cardChooseNumberInputRef.current.value = value;
      setCardChooseNumber(value);
      setPersist("cardChooseNumber", value);
    }
  };
  const onCardChooseExtraInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      cardChooseExtraInputRef.current.value = value;
      setCardChooseExtra(value);
      setPersist("cardChooseExtra", value);
    }
  };

  const onPaymentIndexChange = useCallback(
    (index) => {
      if (typeof index == "undefined") {
        index = paymentIndex;
      } else {
        setPaymentIndex(index);
        setPurseIndex(0);
        setShowSwitchChannelTip(false);
      }
    },
    [payments]
  );

  const targetRef = useRef(null);
  let isMaxLevel = levelConfig ? withdrawLevel === levelConfig.length - 1 : false;
  return (
    <div class={style.page_container}>
      <WithdrawHeader title={langText("withdraw_title_1")} />
      <div class={style.withdraw_content}>
        {NumericalConfig.gasBurnRatio > 0 && (
          <div class={style.withdraw_sub_balance_group}>
            <div class={style.withdraw_sub_balance}>
              <span>Gas remaining</span>
              <span class={style.last}>
                {(gas ? gas : 0).toLocaleString("en-US")}
                {` (for ${(gas ? gas / NumericalConfig.gasBurnRatio : 0).toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                })} ${LocalConfig.currencyCode} max)`}
              </span>
            </div>
            <div class={style.withdraw_sub_balance}>
              <span>Total balance</span>
              <span class={style.last}>
                {(money ? money : 0).toLocaleString("en-US", { maximumFractionDigits: 2 })} {LocalConfig.currencyCode}
              </span>
            </div>
          </div>
        )}
        <div className={style.withdraw_balance}>
          <span>{langText("withdraw_tips_1")}</span>
          <span className={style.last}>
            {withdrawableAmount.toLocaleString("en-US", { maximumFractionDigits: 2 })} <span style={{ fontSize: "0.8rem" }}>{LocalConfig.currencyCode}</span>
          </span>
        </div>
        <div className={style.withdraw_divider}>
          <></>
        </div>
        {NumericalConfig.useWithdrawLevel > 0 && (
          <>
            <div className={style.withdraw_balance}>
              <span>{langText("withdraw_tips_2")}</span>
              <span className={style.last}>
                {suficientData
                  ? (suficientData.total_bet / 100).toLocaleString("en-US", { maximumFractionDigits: 2 })
                  : 0}{" "}
                <span style={{ fontSize: "0.8rem" }}>{LocalConfig.currencyCode}</span>
              </span>
            </div>
            <div className={style.withdraw_divider}>
              <></>
            </div>
          </>
        )}
        {/* <button onClick={()=> {
              if (targetRef.current) {
                targetRef.current.scrollIntoView({ behavior: 'smooth' });
              }
        }}>Scroll to Target</button> */}
        <div className={style.withdraw_balance}>
          <span>{langText("withdraw_tips_71")}</span>
          <span className={style.last}>
            <span style={{ color: "rgb(255, 236, 109)" }}>
              <span>{withdrawableAmount.toLocaleString("en-US", { maximumFractionDigits: 2 })}</span>
            </span>
            {" "}
            <span style={{ fontSize: "0.8rem" }}>{LocalConfig.currencyCode}</span>
            <img
              src={require("@/assets/images/home/wenhao.png").default}
              style={{ width: "1.7rem", height: "1.7rem", marginLeft: "0.2rem", marginTop: "-0.5rem" }}
              alt=""
              onClick={() => {
                setShowHelp(true);
                // if (targetRef.current) {
                //   targetRef.current.scrollIntoView({ behavior: 'smooth' });
                // }
              }}
            />
          </span>
        </div>
        <div className={style.withdraw_divider}>
          <></>
        </div>
        {NumericalConfig.gasBurnRatio > 0 && (
          <div
            class={style.withdraw_sub_balance_group}
            style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: 0 }}
          >
            {money > gas / NumericalConfig.gasBurnRatio && (
              <div class={style.withdraw_sub_desc}>
                <Popover
                  ref={gasPopoverRef}
                  theme="dark"
                  placement="bottom-end"
                  reference={
                    <span class={style.withdraw_get_gas_pop_trigger}>
                      How to withdraw all {(money ? money : 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}{" "}
                      {LocalConfig.currencyCode}?
                    </span>
                  }
                >
                  <div class={style.get_gas_desc}>
                    1 {LocalConfig.currencyCode} withdrawal requires {NumericalConfig.gasBurnRatio} gas. <br />
                    <br />
                    Get gas by <br /> <span onClick={() => onGoPlayClick()}>Playing game</span> (more bets more gas)
                  </div>
                </Popover>
              </div>
            )}
          </div>
        )}

        {payments.length > 0 && (
          <>
            <div class={style.deposit_choose}>
              <div class={style.deposit_top}>
                {payments.map((payment, index) => {
                  return (
                    <div
                      class={index == paymentIndex ? style.fatherbox_active : style.fatherbox}
                      onClick={() => onPaymentIndexChange(index)}
                    >
                      <div class={index == paymentIndex ? style.son_active : style.son}
                        style={index == paymentIndex
                          ? { boxSizing: "border-box", borderRadius: "0.5rem", border: "0.13rem solid rgb(79, 241, 153)" }
                          : { boxSizing: "border-box", borderRadius: "0.5rem", border: "0.13rem solid rgb(81, 142, 117)" }
                        }
                      >
                        {/* {payment.img && (
                          <div style={{ height: "1.3rem", display: "flex", flexDirection: "column", justifyContent: "center", marginBottom:"-0.2rem", marginTop:"0.3rem" }} >
                            <img style={{ maxWidth:"3rem", maxHeight:"1rem", width:"auto", height:"auto" }} src={payment.img} alt="" />
                          </div>
                        )} */}
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "0.2rem",
                            marginBottom: "0.3rem",
                            color: "#fff",
                            fontSize: "0.8rem",
                            fontWeight: "bolder",
                            zIndex: "1",
                          }}
                        // && index == paymentIndex ? {color:"#fff"} : {color:"rgb(145, 184, 168)"}
                        >
                          <span style={index == paymentIndex ? { color: "#fff" } : { color: "rgb(145, 184, 168)" }}>{langText("withdraw_tips_3")}{" " + (index + 1)}</span>
                        </div>
                        {index == paymentIndex && (
                          <div style={{
                            position: "absolute",
                            width: "4.75rem",
                            height: "0.9rem",
                            top: "1.8rem",
                            backgroundColor: "rgb(17, 65, 61)",
                            borderLeft: "0.13rem solid rgb(79, 241, 153)",
                            borderRight: "0.13rem solid rgb(79, 241, 153)",
                            zIndex: "0",
                          }}></div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div class={style.withdraw_channelbox}>
              {/* <img src={require("@/assets/images/home/icon_tanhao.png").default} alt="" />
              <div>
                <div class={style.depositeText} style={{ color: "rgb(80, 198, 119)", fontWeight: "700", fontSize:"0.75rem", marginLeft:"0.3rem" }}>
                  {langText("withdraw_tips_4")}
                </div>
              </div> */}
            </div>
          </>
        )}

        {PaymentConfig.purses[payments[paymentIndex].merchantId] && (
          <>
            <div class={style.purses_choose}>
              <div class={style.deposit_top}>
                {Object.keys(PaymentConfig.purses[payments[paymentIndex].merchantId]).map((payment, index) => {
                  return (
                    <div
                      class={index == purseIndex ? style.fatherbox_active : style.fatherbox}
                      onClick={() => setPurseIndex(index)}
                    >
                      <div class={index == purseIndex ? style.son_active : style.son}
                        style={index == purseIndex
                          ? { boxSizing: "border-box", borderRadius: "0.5rem", border: "0.13rem solid rgb(79, 241, 153)" }
                          : { boxSizing: "border-box", borderRadius: "0.5rem", border: "0.13rem solid rgb(81, 142, 117)" }
                        }
                      >
                        <div style={{ height: "1.3rem", display: "flex", flexDirection: "column", justifyContent: "center", marginBottom: "0.1rem", marginTop: "0.5rem" }} >
                          <img style={{ maxHeight: "1rem", width: "auto", height: "auto" }} src={PaymentConfig.purses[payments[paymentIndex].merchantId][index].icon} alt="" />
                        </div>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            marginTop: "0.2rem",
                            marginBottom: "0.3rem",
                            color: "#fff",
                            fontSize: "0.75rem",
                            fontWeight: "bolder",
                            zIndex: "1",
                          }}
                        >
                          <span style={index == purseIndex ? { color: "#fff" } : { color: "rgb(145, 184, 168)" }}>
                            {PaymentConfig.purses[payments[paymentIndex].merchantId][index].text}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}

        <div class={style.depositeText} style={{ color: "#c3c3c3", fontWeight: "700", fontSize: "0.75rem", marginLeft: "0.3rem" }}>
          {langText("withdraw_tips_4")}
        </div>
        <div class={style.deposit_inbox}>
          <input
            type="text"
            ref={inputRef}
            id={style.withdraw_amount}
            class={style.withdraw_changemoney}
            value={stateWithdraw ? stateWithdraw : ""}
            placeholder={amountPlaceholder}
            onChange={(value) => {
              onWithdrawInputChange(value);
            }}
          />
          <div class={style.withdraw_pol} style={getLanguage() == "bem" && { fontSize: "0.8rem" }}>{langText("withdraw_tips_5")}</div>
          <div class={style.deposit_fork} onClick={() => setStateWithdraw(null)}>
            ×
          </div>
          {/* <p class={style.withdraw_bt}>
            <span>{langText("withdraw_tips_6")}</span>
            <span class={style.withdraw_btr}>
              {stateWithdraw
                ? Math.floor(
                    (stateWithdraw *
                      (100 -
                        (NumericalConfig.useWithdrawLevel
                          ? levelConfig[withdrawLevel].withdraw_service_fee * 100
                          : NumericalConfig.withdrawFeePercent))) /
                      100
                  ).toFixed(2)
                : "0.00"}{" "}
              {LocalConfig.currencyCode}
            </span>
          </p> */}
          {NumericalConfig.gasBurnRatio > 0 && (
            <p class={style.withdraw_bt}>
              <span>Gas consumption</span>
              <span class={style.withdraw_btr}>
                {stateWithdraw ? Math.ceil(stateWithdraw * NumericalConfig.gasBurnRatio).toFixed(0) : "0"}
              </span>
            </p>
          )}
          <p className={style.withdraw_fee}>
            {NumericalConfig.useWithdrawLevel > 0 ? (
              <span>
                {withdrawLevel > 0 ? (
                  <>
                    {langText("withdraw_tips_7_1")}{" "}
                    <span className={style.withdraw_fee_percent}>{`${levelConfig[withdrawLevel].withdraw_service_fee * 100
                      }%`}</span>
                    , {langText("withdraw_tips_7_2")}
                  </>
                ) : (
                  "No withdrawal service fee."
                )}
              </span>
            ) : (
              <>
                {/* {NumericalConfig.withdrawFeePercent > 0 && (
                  <span>
                    service fee of <span className={style.withdraw_bc}>{NumericalConfig.withdrawFeePercent}%</span>,{" "}
                  </span>
                )}
                {langText("withdraw_tips_22")} */}
              </>
            )}
          </p>
        </div>
        {payments[paymentIndex] && payments[paymentIndex].type == "BANKCARD" && (
          <>
            {/* <div class={style.withdraw_balance} style={{ marginTop: "0.5rem" }}>
              <span>{langText("withdraw_tips_25")}</span>
            </div> */}
            {/* <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={bankNameInputRef}
                class={style.withdraw_changemoney}
                value={bankName ? bankName : ""}
                placeholder={"Bank name"}
                onChange={(value) => {
                  onBankInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>Bank</div>
              <div class={style.deposit_fork} onClick={() => setBankName("")}>
                ×
              </div>
            </div> */}
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={bankCodeInputRef}
                class={style.withdraw_changemoney}
                value={bankCode ? bankCode : ""}
                placeholder={langText("withdraw_tips_28")}
                onChange={(value) => {
                  onBankCodeInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>IFSC</div>
              <div class={style.deposit_fork} onClick={() => setBankCode("")}>
                ×
              </div>
            </div>
            <div style={{ marginLeft: "0.3rem", marginTop: "0.3rem" }}>
              {langText("withdraw_tips_74")}
            </div>
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={accountNameInputRef}
                class={style.withdraw_changemoney}
                value={accountName ? accountName : ""}
                placeholder={langText("withdraw_tips_30")}
                onChange={(value) => {
                  onAccountInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{langText("withdraw_tips_29")}</div>
              <div class={style.deposit_fork} onClick={() => setAccountName("")}>
                ×
              </div>
            </div>
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={cardNumberInputRef}
                class={style.withdraw_changemoney}
                value={cardNumber ? cardNumber : ""}
                placeholder={langText("withdraw_tips_32")}
                onChange={(value) => {
                  onCardInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{langText("withdraw_tips_31")}</div>
              <div class={style.deposit_fork} onClick={() => setCardNumber("")}>
                ×
              </div>
            </div>
            <p class={style.withdraw_fee} style={{ fontSize: "0.8rem" }}>
              {langText("withdraw_tips_33")} {langText("withdraw_tips_35")}
            </p>
          </>
        )}

        {payments[paymentIndex] && payments[paymentIndex].type == "BANKCHOOSE" && (
          <>
            {/* <div class={style.withdraw_balance} style={{ marginTop: "0.5rem" }}>
              <span>{langText("withdraw_tips_25")}</span>aaaaa
            </div> */}
            {PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "BANK" && (
              <div class={style.deposit_inbox} onClick={() => setShowCodeChooseChannel(true)}>
                <div class={style.withdraw_pol}>{langText("withdraw_tips_93")}</div>
                <div class={style.withdraw_changemoney}>{codes[codeIndex] && codes[codeIndex].text}</div>
                <img class={style.withdraw_jiantou} src={require("@/assets/images/home/jiantou2.png").default} />
                <p />
              </div>
            )}
            {/* {PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex] == "JAZZCASH" && (
              <div style={{marginLeft:"0.3rem", marginTop:"0.3rem"}}>
                {langText("withdraw_tips_69")}
              </div>
            )} */}
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={bankChooseNameInputRef}
                class={style.withdraw_changemoney}
                value={bankChooseName ? bankChooseName : ""}
                placeholder={langText("withdraw_tips_30")}
                onChange={(value) => {
                  onBankChooseNameInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{langText("withdraw_tips_29")}</div>
              <div class={style.deposit_fork} onClick={() => setBankChooseName("")}>
                ×
              </div>
            </div>
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={cardChooseNumberInputRef}
                class={style.withdraw_changemoney}
                value={cardChooseNumber ? cardChooseNumber : ""}
                placeholder={(codes[bankChooseCode].id == "EASYPAISA" || codes[bankChooseCode].id == "JAZZCASH") ? langText("withdraw_tips_68") : langText("withdraw_tips_32")}
                onChange={(value) => {
                  onCardChooseNumberInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{(codes[bankChooseCode].id == "EASYPAISA" || codes[bankChooseCode].id == "JAZZCASH") ? langText("withdraw_tips_66") : langText("withdraw_tips_31")}</div>
              <div class={style.deposit_fork} onClick={() => setCardChooseNumber("")}>
                ×
              </div>
            </div>
            {payments[paymentIndex].merchantId == 27 && PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "JAZZCASH" && (
              <div class={style.deposit_inbox}>
                <input
                  type="text"
                  ref={cardChooseExtraInputRef}
                  class={style.withdraw_changemoney}
                  value={cardChooseExtra ? cardChooseExtra : ""}
                  placeholder={langText("withdraw_tips_76")}
                  onChange={(value) => {
                    onCardChooseExtraInputChange(value);
                  }}
                />
                <div class={style.withdraw_pol}>CNIC</div>
                <div class={style.deposit_fork} onClick={() => setCardChooseExtra("")}>
                  ×
                </div>
              </div>
            )}
            {payments[paymentIndex].merchantId == 27 && PaymentConfig.purses[payments[paymentIndex].merchantId][purseIndex].text == "JAZZCASH" && (
              <div style={{ marginLeft: "0.3rem", marginTop: "0.3rem" }}>
                {langText("withdraw_tips_69")}
              </div>
            )}
            <p class={style.withdraw_fee} style={{ fontSize: "0.8rem" }}>
              {langText("withdraw_tips_33")} {langText("withdraw_tips_35")}
            </p>
          </>
        )}

        {payments[paymentIndex] && payments[paymentIndex].type == "BANKNAME" && (
          <>
            {/* <div class={style.withdraw_balance} style={{ marginTop: "0.5rem" }}>
              <span>{langText("withdraw_tips_58")}</span>
            </div> */}
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={bankCodeTwoInputRef}
                class={style.withdraw_changemoney}
                value={bankCodeTwo ? bankCodeTwo : ""}
                placeholder={langText("withdraw_tips_63")}
                onChange={(value) => {
                  onBankCodeTwoInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{langText("withdraw_tips_61")}</div>
              <div class={style.deposit_fork} onClick={() => setBankCodeTwo("")}>
                ×
              </div>
            </div>

            {/* <div class={style.deposit_inbox} onClick={() => setShowNameChooseChannel(true)}>
              <div class={style.withdraw_pol}>{langText("withdraw_tips_29")}</div>
              <div class={style.withdraw_changemoney}>{names[nameIndex] && names[nameIndex].text}</div>
              <img class={style.withdraw_jiantou} src={require("@/assets/images/home/jiantou2.png").default} />
              <p />
            </div> */}
            {/* <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={bankNameTwoInputRef}
                class={style.withdraw_changemoney}
                value={bankNameTwo ? bankNameTwo : ""}
                placeholder={langText("withdraw_tips_64")}
                onChange={(value) => {
                  onBankNameTwoInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{langText("withdraw_tips_29")}</div>
              <div class={style.deposit_fork} onClick={() => setBankNameTwo("")}>
                ×
              </div>
            </div> */}
            <p class={style.withdraw_fee} style={{ fontSize: "0.8rem" }}>
              {langText("withdraw_tips_33")} {langText("withdraw_tips_35")}
            </p>
          </>
        )}
        {payments[paymentIndex] && payments[paymentIndex].type == "UPI" && (
          <>
            {/* <div class={style.withdraw_balance} style={{ marginTop: "0.5rem" }}>
              <span>{langText("withdraw_tips_26")}</span>
            </div> */}
            <div class={style.deposit_inbox}>
              <input
                type="text"
                ref={bankAccountInputRef}
                class={style.withdraw_changemoney}
                value={bankAccount ? bankAccount : ""}
                placeholder={langText("withdraw_tips_27")}
                onChange={(value) => {
                  onBankAccountInputChange(value);
                }}
              />
              <div class={style.withdraw_pol}>{langText("promotion_title_3")}</div>
              <div class={style.deposit_fork} onClick={() => setBankAccount("")}>
                ×
              </div>
            </div>
            <p class={style.withdraw_fee}>
              {langText("withdraw_tips_34")} {langText("withdraw_tips_35")}
            </p>
          </>
        )}

        {NumericalConfig.useWithdrawLevel > 0 && (
          <>
            {/* <div class={style.invite_whole}>
              <></>
            </div> */}
            <div class={style.level_div}>
              <div class={style.level_card}>
                <p class={style.withdraw_level}>
                  <span>
                    {langText("withdraw_title_2", { param1: withdrawLevel })}
                  </span>
                </p>
                <div class={style.level_card_progress}>
                  <span class={style.level_card_progress_level} style={
                    getLanguage() == "bem" && { fontSize: "0.9rem", marginLeft: "1rem" } || { marginLeft: "1rem" }
                  }>{langText("withdraw_tips_8", { param1: withdrawLevel })}</span>
                  <div class={style.level_card_progress_bar}>
                    <InviteProgress2
                      width="100%"
                      height={"1.3rem"}
                      borderRadius={"1.2rem"}
                      percentage={`${isMaxLevel && isMaxLevel
                        ? 1.0
                        : withdrawExp / levelConfig[withdrawLevel + 1].exp * 100
                        }`}
                      textColor={"#fff"}
                      fontSize={"0.9rem"}
                      progressColor={"#34d0d6"}
                      backgroundColor={"#043330"}
                      text={`${isMaxLevel
                        ? FormatNumberToKMB(withdrawExp / 100, ["K"], 2)
                        : `${FormatNumberToKMB(withdrawExp / 100, ["K"], 2)}/${FormatNumberToKMB(
                          levelConfig[withdrawLevel + 1].exp / 100,
                          ["K"],
                          2
                        )}`
                        }`}
                    />
                  </div>
                  <span class={style.level_card_progress_level} style={
                    getLanguage() == "bem" && { fontSize: "0.9rem", marginRight: "1rem" } || { marginRight: "1rem" }
                  }>
                    {isMaxLevel ? "" : langText("withdraw_tips_8", { param1: withdrawLevel + 1 })}
                  </span>
                </div>
                {isMaxLevel ? null : (
                  <div class={style.level_card_next_hint}>
                    {langText("withdraw_tips_70", { param1: FormatNumberToKMB(levelConfig[withdrawLevel + 1].exp / 100, ["K"], 2) })}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
        <div class={style.btncommontwo}>
          <div class={style.paybtnbox} style={{ marginTop: "-0.5rem" }}>
            <button
              class={`${style.paybtn} ${style.paybtn1}${stateWithdraw < minWithdraw / 100 ? ` ${style.paybtn_disabled}` : ""
                }`}
              onClick={() => doWithdraw()}
            >
              {langText("withdraw_title_1")}
            </button>
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row", marginTop: "0.5rem" }}>
          <div style={{ color: "rgb(157, 157, 157)", fontWeight: "bolder", fontSize: "0.8rem", marginTop: "0.3rem", marginLeft: "0.5rem", marginRight: "0.5rem" }}>
            <span>
              {langText("service_tips_2")}
            </span>
          </div>
        </div>
        <div style={{ color: "rgb(157, 157, 157)", fontWeight: "bolder", fontSize: "0.8rem", marginTop: "0.3rem", marginLeft: "0.5rem", marginRight: "0.5rem" }}>
          <span style={{ color: "rgb(112, 219, 106)" }}>
            {contactType}:&nbsp;
          </span>
          <CopyToClipboard
            text={contactNumber}
            onCopy={() => {
              Toast.success({
                message: "Copy Successfully",
              });
            }}
          >
            <span style={{ color: "#fff", textDecoration: "underline" }}>
              @{contactNumber}
              <img style={{ width: "1rem", height: "1rem", marginLeft: "0.4rem" }} src={require("@/assets/icons/copy.png").default} />
            </span>
          </CopyToClipboard>
        </div>
        {FunctionalConfig.pakistanLeader && (
          <div class={style.deposit_describe} style={{ marginTop: "1rem", marginBottom: "-0.5rem" }}>
            <h4 style={{ marginLeft: "0.2rem", color: "rgb(68, 141, 64)" }}>{langText("withdraw_title_17")}</h4>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(151, 216, 178)" }}>1.</span>
              <span style={{ color: "rgb(151, 216, 178)" }}> {langText("withdraw_tips_55")} </span>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(151, 216, 178)" }}>2.</span>
              <span style={{ color: "rgb(151, 216, 178)" }}> {langText("withdraw_tips_56")} </span>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(151, 216, 178)" }}>3.</span>
              <span style={{ color: "rgb(151, 216, 178)" }}> {langText("withdraw_tips_57")} </span>
            </div>
          </div>
        )}
        <div ref={targetRef} class={style.deposit_describe}>
          <h5>{langText("withdraw_title_3")}</h5>
          {NumericalConfig.useWithdrawLevel > 0 && (
            <>
              <div class={inviteRouteStyle.rule_level_table} style={{ marginBottom: "2rem", fontWeight: 700 }}>
                <table>
                  <thead>
                    <tr>
                      <td>{langText("withdraw_title_4")}</td>
                      <td>{langText("withdraw_title_5")}</td>
                      <td>{langText("withdraw_title_6")}</td>
                    </tr>
                  </thead>
                  <tbody>
                    {levelConfig.map((item) => {
                      return (
                        <tr key={item.level}>
                          <td>{langText("withdraw_tips_8", { param1: item.level })}</td>
                          <td>
                            {item.level > 0
                              ? item.level === levelConfig.length - 1
                                ? langText("withdraw_tips_11")
                                : levelConfig[item.level].withdraw_limit / 100
                              : langText("withdraw_tips_21")}
                          </td>
                          <td>{item.level > 0 ? `${levelConfig[item.level].withdraw_service_fee * 100}%` : "---"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <p> {langText("withdraw_tips_12")} </p>
          <p>
            {" "}
            {langText("withdraw_tips_13", { param1: LocalConfig.currencyCode, param2: (minWithdraw / 100).toFixed(2) })}
          </p>
          <p>
            {" "}
            {langText("withdraw_tips_14", { param1: LocalConfig.currencyCode, param2: (maxWithdraw / 100).toFixed(2) })}
          </p>
          <p> {langText("withdraw_tips_15")} </p>
          <p> {langText("withdraw_tips_16")} </p>
          <p> {langText("withdraw_tips_17")} </p>
          {FunctionalConfig.newPromotion && (
            <p> 7. After recharging, you need to complete 1 times of turnover before you can withdraw cash. After purchasing the first recharge gift package, you need to complete 600 times of turnover before you can withdraw cash. </p>
          )}
          {NumericalConfig.gasBurnRatio > 0 && (
            <>
              <p>
                7. Gas must be consumed for withdrawal transactions; each withdrawal of 1{LocalConfig.currencyCode}{" "}
                requires the consumption of 10 gas units.
              </p>
              <p>8. Get gas by playing games (the more you bet the more gas you will get) or depositing.</p>
            </>
          )}
        </div>

        <div class={style.deposit_phone}>
          <img src={LocationInfo().flag} alt="" />
          <span class={style.deposit_pc}>+{LocationInfo().phoneStartsWith}</span>
          <span>{getPersist("user_info") ? getPersist("user_info").rolename : null}</span>
        </div>
        <p class={style.depositedes}>
          {langText("withdraw_tips_10")}
        </p>

      </div>
      <div className={style.drop_down_anim} >
        <img style={{ width: "auto", height: "1.1rem" }} src={require("@/assets/images/home/drop_down.png").default} alt="" />
      </div>
      <DownloadFloatBall floatBall={downloadFloatBall} onClose={() => setDownloadFloatBall(false)} />
      <Popup
        visible={showChooseChannel}
        style={{ height: "30%" }}
        position="bottom"
        className={style.withdrawChooseChannelDialog}
        onClose={() => {
          setShowChooseChannel(false);
        }}
      >
        <Picker
          columns={payments}
          placeholder={null}
          confirmButtonText={langText("withdraw_btn_1")}
          cancelButtonText={langText("withdraw_btn_2")}
          defaultValue={paymentIndex}
          onChange={(value) => {
            if (!payments[value]) {
              value = 0;
            }
            setPaymentIndex(value);
          }}
          onCancel={() => {
            setShowChooseChannel(false);
          }}
          onConfirm={() => {
            setShowChooseChannel(false);
          }}
        />
      </Popup>
      <Popup
        visible={showCodeChooseChannel}
        style={{ height: "30%" }}
        position="bottom"
        className={style.withdrawChooseChannelDialog}
        onClose={() => {
          setShowCodeChooseChannel(false);
        }}
      >
        <Picker
          columns={codes}
          placeholder={null}
          confirmButtonText={langText("withdraw_btn_1")}
          cancelButtonText={langText("withdraw_btn_2")}
          defaultValue={codeIndex}
          onChange={(value) => {
            if (!codes[value]) {
              value = 0;
            }
            setCodeIndex(value);
            setBankChooseCode(value);
            setPersist("bankChooseCode", value);
          }}
          onCancel={() => {
            setShowCodeChooseChannel(false);
          }}
          onConfirm={() => {
            setShowCodeChooseChannel(false);
          }}
        />
      </Popup>
      <Popup
        visible={showNameChooseChannel}
        style={{ height: "30%" }}
        position="bottom"
        className={style.withdrawChooseChannelDialog}
        onClose={() => {
          setShowNameChooseChannel(false);
        }}
      >
        <Picker
          columns={names}
          placeholder={null}
          confirmButtonText={langText("withdraw_btn_1")}
          cancelButtonText={langText("withdraw_btn_2")}
          defaultValue={nameIndex}
          onChange={(value) => {
            if (!names[value]) {
              value = 0;
            }
            setNameIndex(value);
            setBankNameTwo(value);
            setPersist("bankNameTwo", value);
          }}
          onCancel={() => {
            setShowNameChooseChannel(false);
          }}
          onConfirm={() => {
            setShowNameChooseChannel(false);
          }}
        />
      </Popup>
      <Popup
        className={style.withdrawUnSuficientDialog}
        visible={suficientData && !suficientData.sufficient}
        // visible={1}
        title={langText("withdraw_title_16")}
        closeable={false}
      >
        {suficientData ? (
          <div style={{ width: "85vw", backgroundColor: "#083d2b" }}>
            <div class={style.unsuficientCard}>
              <div class={style.unsuficientProp}>
                {`${suficientData.total_bet / 100} / ${suficientData.first_recharge_bet_need / 100}`}
              </div>
              <InviteProgress
                width="100%"
                height={"1.3rem"}
                borderRadius={"1.2rem"}
                percentage={(suficientData.total_bet / suficientData.first_recharge_bet_need) * 100}
                // textColor={"#e700fc"}
                // fontSize={"0.6rem"}
                // progressColor={"#ffd700"}
                // backgroundColor={"#010101"}
                text={`${suficientData.total_bet / 100} / ${suficientData.first_recharge_bet_need / 100}`}
              />
            </div>
            <div class={style.unsuficientTip}>
              {NumericalConfig.useWithdrawLevel ? "Since you take the deposit bonus. " : ""}{langText("withdraw_tips_23")}{" "}
              <span>
                {(suficientData.first_recharge_bet_need - suficientData.total_bet) / 100} {LocalConfig.currencyCode}
              </span>{" "}
              {langText("withdraw_tips_24")}
            </div>
            <div class={style.btncommontwo} style={{ padding: "1rem", width: "90%" }}>
              <div class={style.paybtnbox}>
                <button class={`${style.paybtn} ${style.paybtn1}`} onClick={() => history.goBack()}>
                  {langText("withdraw_btn_5")}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </Popup>
      <Popup
        visible={showHelp}
        className={style.helpPopup}
        closeable={true}
        onClose={() => setShowHelp(false)}
      >
        <div class={style.helpLabel}>
          <div style={{ width: "100%", textAlign: "center", marginBottom: "2rem", fontWeight: "700", fontSize: "1.2rem" }}>
            {langText("withdraw_tips_79")}
          </div>
          <div class={style.depevebox}>
            <p>
              {langText("withdraw_tips_80", { param1: LocalConfig.currencyCode, param2: LocalConfig.currencyCode })}
            </p>
            <p>
              {langText("withdraw_tips_81", { param1: LocalConfig.currencyCode, param2: LocalConfig.currencyCode })}
            </p>
            <div style={{ textAlign: "center", width: "100%", marginTop: "0.5rem", marginBottom: "1rem" }}>
              <h5>{langText("withdraw_title_3")}</h5>
            </div>
            <p> {langText("withdraw_tips_12")} </p>
            <p>{langText("withdraw_tips_13", { param1: LocalConfig.currencyCode, param2: (minWithdraw / 100).toFixed(2) })}</p>
            <p>{langText("withdraw_tips_14", { param1: LocalConfig.currencyCode, param2: (maxWithdraw / 100).toFixed(2) })}</p>
            <p> {langText("withdraw_tips_15")} </p>
            <p> {langText("withdraw_tips_16")} </p>
            <p> {langText("withdraw_tips_17")} </p>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default Withdraw;
